import Bugatti from "./car-detail/Bugatti";
import Ferrari from "./car-detail/Ferrari";
import Lamborghini from "./car-detail/Lamborghini";
import MercedesBenz from "./car-detail/MercedesBenz";
import Pagani from "./car-detail/Pagani";
import AstonMartin from "./car-detail/AstonMartin";
import Arrinera from "./car-detail/Arrinera";
import Audi from "./car-detail/Audi";
export const Cars = [
    Bugatti,
    Ferrari,
    Lamborghini,
    MercedesBenz,
    Pagani,
    AstonMartin,
    Arrinera,
    Audi,
];

let AllCar = [];
Cars.map((car) => {
    return (AllCar = AllCar.concat(car));
});
export default AllCar;
